/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360RetailerApiModelsCreateNfcOperationRequest {
    PlaceIDs?: Array<number>;
    ProductIDs?: Array<string>;
    CategoryIDs?: Array<number>;
    /**
     * 1 = All, 2 = AssignProductsWithoutStickers
     */
    AssignType?: Open360RetailerApiModelsCreateNfcOperationRequest.AssignTypeEnum;
    FirstStickerNumber?: string;
}
export namespace Open360RetailerApiModelsCreateNfcOperationRequest {
    export type AssignTypeEnum = 1 | 2;
    export const AssignTypeEnum = {
        NUMBER_1: 1 as AssignTypeEnum,
        NUMBER_2: 2 as AssignTypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360RetailerApiModelsCreateNfcOperationRequest.ts